import { YES_FLAG, NO_FLAG } from '../../shared/constants';

export const compareScenario = (s1, s2) => s1.scenarioName === s2.scenarioName;

export const getScenarioStatus = ({ modifiedFlag, lockedFlag }) => {
  if (modifiedFlag === YES_FLAG) {
    return 'Modified';
  }
  if (lockedFlag === YES_FLAG) {
    return 'Locked';
  }
  if (lockedFlag === NO_FLAG) {
    return 'Unlocked';
  }
  return '';
};
